<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :parentStoreName="parentStoreName"
    :submit="submit" :status="status" :breadcrumbs="[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/help_options'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Titulo</div>
                <v-text-field :error-messages="errors" v-model="data.title" label="Titulo"
                  prepend-inner-icon="fas fa-file" solo hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col class="py-0 px-2">
              <ValidationProvider ref="requires_photo" rules="" v-slot="{ errors }">
                <v-checkbox :error-messages="errors" label="Requiere Foto" v-model.number="data.requires_photo"
                  class="input-check-base mt-0" hide-details="auto" on-icon="$checkedIcon" off-icon="$unCheckedIcon">
                </v-checkbox>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="requires_description" rules="" v-slot="{ errors }">
                <v-checkbox :error-messages="errors" label="Requiere Descripcion"
                  v-model.number="data.requires_description" class="input-check-base mt-0" hide-details="auto"
                  on-icon="$checkedIcon" off-icon="$unCheckedIcon">
                </v-checkbox>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from 'vuex';
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from '@/mixins/crud_form';

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: state => state.Help_options.status,
    })
  },
  data() {
    return {
      storeName: 'Help_options',
      parentStoreName: 'Help_options',
      title: "Opciones de Ayuda",
      data: {
        title: '',
        description: '',
        requires_photo: false,
        requires_description: false
      }
    }
  }
}
</script>
